import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const coreBackupWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [{ path: '/admin/backups', component: () => import('./pages/BackupsPage.js') }],
  widgets: { 'core-backup.status': () => import('./StatusWidget.js') },
});
